import React from "react";
import utils from "../../app/UtilityService";
import StringUtils from "@tinqin/tinqin-utils/src/string";
import containerUtils, {
    getEmptyContent,
    resolveChildren,
    dispatchSirenActions
} from "../../utils/containerUtils";

//connected basic container
//hidden - property for visibility of the DOM element -  default:false
//adds uniqueId property to the DOM element to be selectable on global level
//usable for Scrolling and Printing actions
export function SmartContainer(props) {
    const onEvent = (reactEvent) => {
        dispatchSirenActions(props, [reactEvent]);
    };
    if (!props.data) {
        return getEmptyContent();
    }
    let data = props.data;
    let dataProps = data.properties || {};
    let smartContainerProps = containerUtils.extractComponentProps(props, {
        propsDefaults: {
            visible: true,
            extraClasses: ""
        },
        additionalProps: [
            "extraClasses",
            "tag", //HTML tag name
            "style", //React supported style object
            "text", //Plain text inside the tag (ignore children)
            "dispatchOnReactEvents", // Array with names of events that trigger the action
            // construct onEvent handler name: click -> onClick and so on
            // use same names for event in dispatchOnReactEvents: [click] and action: { events: [click] ... }
            "resolveWhenHidden", //Render children even the container is hidden,
            "visible"
        ]
    });

    if (!smartContainerProps.visible && !smartContainerProps.resolveWhenHidden) {
        return getEmptyContent();
    }

    const createElementConstraint = [
        smartContainerProps.extraClasses,
        smartContainerProps.style,
        smartContainerProps.text,
        smartContainerProps.dispatchOnReactEvents,
        smartContainerProps.visible === false
    ];

    const existConstraint = createElementConstraint.some((property) => property);

    if (!smartContainerProps.tag && existConstraint) {
        smartContainerProps.tag = "div";
    }

    if (!smartContainerProps.tag) {
        return resolveChildren(props);
    }

    let tagId = dataProps.id || props.computedBindTo;

    let propsToPass = {
        "data-tq-id": tagId,
        "data-unique-id": tagId,
        className: smartContainerProps.visible
            ? smartContainerProps.extraClasses
            : smartContainerProps.extraClasses + " tq-hide",
        style: smartContainerProps.style,
        key: tagId //key added to be able to force inner components re-initializations
    };

    if (smartContainerProps.dispatchOnReactEvents) {
        smartContainerProps.dispatchOnReactEvents.forEach((reactEvent) => {
            // use same names for event in dispatchOnReactEvents: [click] and action: { events: [click] ... }
            // construct onEvent handler name: click -> onClick
            let reactEventName = "on" + StringUtils.capitalizeFirstLetter(reactEvent);
            propsToPass[reactEventName] = () => onEvent(reactEvent);
        });
    }

    let children = smartContainerProps.text || resolveChildren(props);

    return React.createElement(smartContainerProps.tag, propsToPass, children);
}

SmartContainer.displayName = "SmartContainer";

export default utils.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions"
    }
})(SmartContainer);
